const COUPONS_AND_DISCOUNTS_SUMMARY = {
  totalCoupon: {
    label: 'Cupom',
    tooltipText: 'Valor restituído do cupom utilizado no pedido.',
  },
  totalDiscount: {
    label: 'Desconto Zé',
    tooltipText:
      'Restituição de promoções aplicadas automaticamente pelo Zé nos produtos.',
  },
  totalSampling: {
    label: 'Brindes e Experimentação',
    tooltipText:
      'Restituição do valor de produtos vendidos a preço simbólico no Zé para experimentação do cliente',
  },
  turbine: {
    label: 'Turbine',
    value: 'Valores já aplicados nos pedidos',
    tooltipText:
      'Valor que você bancou ao aplicar descontos adicionais em produtos.',
  },

  downloadButtonTextSuffix: 'cupons e descontos por pedido',
  errorMessage:
    'Houve um erro ao carregar o resumo de cupons e descontos. Tente novamente mais tarde.',
  errorMessageCouponsAndDiscountsTotalMismatch:
    'Restitution details coupons and discounts total mismatch',
}

export default COUPONS_AND_DISCOUNTS_SUMMARY
